'use client'

import { emailReceipt } from '@/lib/actions/order/email-receipt'
import { useModals, useSelectedCustomer } from '@/lib/hooks'
import { Loader2, Mail } from 'lucide-react'
import React from 'react'
import { toast } from 'sonner'

import { Button, Input } from '@/components/ui'

export const EmailReceipt = ({ orderId }: { orderId: string }) => {
  const { closeModal } = useModals()
  const { customer } = useSelectedCustomer()
  const [isSending, startSending] = React.useTransition()
  const [customerEmail, setCustomerEmail] = React.useState(customer?.email ?? '')

  const handleSubmit = async (data: FormData) => {
    const email = data.get('email') as string

    if (!email) {
      toast.error('Please enter an email address')
      return
    }

    startSending(async () => {
      try {
        const res = await emailReceipt({ orderId, email })

        if (res?.error) {
          toast.error(res?.error)
          return
        }

        toast.success('Email receipt sent successfully.')
        closeModal('EMAIL_RECEIPT')
      } catch {
        toast.error('Failed to send email receipt. Please try again.')
      }
    })
  }

  return (
    <form
      className="flex w-full flex-wrap gap-4 lg:gap-8"
      action={handleSubmit}
    >
      <div className="flex w-full flex-col flex-wrap gap-4">
        <h2 className="text-balance text-xl font-medium">Email Receipt</h2>

        <div className="flex w-full flex-col gap-5">
          <Input
            className="w-full appearance-none text-center"
            value={customerEmail}
            onChangeValue={(value) => {
              setCustomerEmail(value)
            }}
            inputSize="lg"
            name="email"
            type="email"
            placeholder="john.doe@example.com"
            autoFocus
          />
        </div>

        <div className="flex w-full gap-2 pt-3">
          <Button
            variant="default"
            className="w-full gap-3 shadow-card"
            size="lg"
            type="submit"
            disabled={isSending}
          >
            {isSending && <Loader2 className="size-5 animate-spin" />}
            {!isSending && <Mail className="size-5" strokeWidth={1.5} />}
            <span>Send Receipt</span>
          </Button>
        </div>
      </div>
    </form>
  )
}
